import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AssinarPdfModal from "./AssinarPdfModal";
import { obterArquivoAnexo } from "../../../utils/solicitacoes/anexoCache";
import { ehImagemAssinavel, imagemParaPdf, nomeSemExtensao } from "../../../utils/solicitacoes/imagemParaPdf";

// Anexo já existe no backend: baixa o PDF antes de abrir o editor de assinatura e, ao confirmar,
// substitui o arquivo do anexo existente (mesmo id/registro) pelo PDF assinado.
export default function AssinarAnexoModal({ anexo, onClose, onAssinado, rateioItens, rateioItensDetalhados, formaPagamento }) {
    const [pdfBlob, setPdfBlob] = useState(null);
    const [erroCarregar, setErroCarregar] = useState(null);

    useEffect(() => {
        if (!anexo) return undefined;
        let cancelado = false;
        setPdfBlob(null);
        setErroCarregar(null);

        obterArquivoAnexo(anexo)
            // Imagem anexada: vira um PDF de uma página pra passar pelo mesmo fluxo de assinatura.
            .then(({ blob }) => ehImagemAssinavel(anexo.nomeOriginal) ? imagemParaPdf(blob) : blob)
            .then(blob => { if (!cancelado) setPdfBlob(blob); })
            .catch(error => {
                console.error("Erro ao baixar anexo para assinatura", error);
                if (!cancelado) setErroCarregar("Não foi possível carregar o documento para assinatura.");
            });

        return () => { cancelado = true; };
    }, [anexo]);

    const documento = anexo ? {
        titulo: `Assinar: ${anexo.nomeOriginal}`,
        nomeArquivoSaida: `assinado_${ehImagemAssinavel(anexo.nomeOriginal) ? `${nomeSemExtensao(anexo.nomeOriginal)}.pdf` : anexo.nomeOriginal}`,
        blob: pdfBlob,
    } : null;

    return (
        <AssinarPdfModal
            documento={documento}
            erroCarregar={erroCarregar}
            rateioItens={rateioItens}
            rateioItensDetalhados={rateioItensDetalhados}
            formaPagamento={formaPagamento}
            onClose={onClose}
            onConfirmar={async arquivoAssinado => {
                await onAssinado(anexo.id, arquivoAssinado);
                toast.success("Documento assinado com sucesso!");
            }}
        />
    );
}
